import { render } from "./Identity.vue?vue&type=template&id=3c99afd5&scoped=true"
import script from "./Identity.vue?vue&type=script&lang=js"
export * from "./Identity.vue?vue&type=script&lang=js"

import "./Identity.vue?vue&type=style&index=0&id=3c99afd5&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c99afd5"]])

export default __exports__